<script>
  import Vue from 'vue';
  import VueResource from 'vue-resource';

  Vue.use(VueResource);

  export default {
    props: {
      titulo: '',
      nomeProjeto: '',
      borda: {
        type: String,
        default: 'hr-line-dashed',
      },
    },
    data() {
      return {
        urlImagem: true,
      }
    },
    methods: {
      verificarUrlImagem() {
        Vue.http.get('/img/logo-impressao.png')
          .then(() => {
            this.urlImagem = true;
          }).catch(() => {
            this.urlImagem = false;
          });
      }
    },
    mounted() {
      this.verificarUrlImagem();
    },
    computed: {
      data() {
        return moment().format('DD [de] MMMM [de] YYYY [as] HH:mm:ss');//22 de maio de 2017 / Hora: 13:16:23
      }
    }
  }
</script>


<template>
  <div class="visible-print">
    <div class="flex-container">
      <div v-if="urlImagem" class="flex-item">
        <img src="/img/logo-impressao.png" class="img-responsive" alt="logo empresa">
      </div>
      <div v-else class="flex-item">
        <img src="/img/logo-impressao-gemini.png" class="img-responsive" alt="logo gemini">
      </div>

      <div class="flex-item padding-25"></div>

      <div class="flex-item-2">
        <h3><b>{{ titulo }}</b></h3>
        <h4>{{ nomeProjeto }}</h4>

        <p class="no-margins small">Data: {{ data }}</p>
      </div>
    </div>

    <hr :class="[`${borda} margin-10`]">
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/CabecalhoRelatorio.vue